<template>
    <activation-brief-agreements-provider
        v-slot="{
            brief,
            step,
            patchStep,
            goNextStep,
            goPreviousStep,
            isPreview,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage,
            usesAlternateTerms,
        }"
        style="height: 100%">
        <activation-brief-agreements-view
            :brief="brief"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :errors="errors"
            :error-message="errorMessage"
            :uses-alternate-terms="usesAlternateTerms"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
        />
    </activation-brief-agreements-provider>
</template>

<script>
    import ActivationBriefAgreementsProvider
        from '../providers/activation-brief-steps/ActivationBriefAgreementsProvider';
    import ActivationBriefAgreementsView from '../data-views/activation-briefs/ActivationBriefAgreementsView';
    export default {
        name:       'ActivationBriefAgreementsRouterView',
        components: {
            ActivationBriefAgreementsView,
            ActivationBriefAgreementsProvider,
        },
    };
</script>
